/** @format */

export function GbDraggableDirective() {
    return {
        restrict: 'A',
        scope: {
            gbOnDrag: '&?',
            gbOnDrop: '&?',
        },
        controller: class GbDraggableDirective {
            constructor($element, $scope) {
                'ngInject';

                this.$element = $element;
                this.$scope = $scope;
            }

            getElement() {
                return this.$element;
            }

            $onInit() {
                this.getElement().css('position', 'absolute');

                this.gbOnDrag = this.$scope.gbOnDrag;
                this.gbOnDrop = this.$scope.gbOnDrop;
            }
        },
    };
}
